import { usePopover } from 'minimal-shared/hooks';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';

import { Iconify } from 'src/components/iconify';
import { CustomPopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

type Props = {
  sort: string;
  onSort: (newValue: string) => void;
  sortOptions: {
    value: string;
    label: string;
  }[];
  setShowMap: (show: boolean) => void;
  showMap: boolean;
};

export function ProductSort({ sort, onSort, sortOptions, setShowMap, showMap }: Props) {
  const menuActions = usePopover();

  const sortLabel = sortOptions.find((option) => option.value === sort)?.label;

  const renderMenuActions = () => (
    <CustomPopover
      open={menuActions.open}
      anchorEl={menuActions.anchorEl}
      onClose={menuActions.onClose}
    >
      <MenuList>
        {sortOptions.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === sort}
            onClick={() => {
              menuActions.onClose();
              onSort(option.value);
            }}
            sx={{ py: 1, px: 2, fontFamily: 'Rubik', fontSize: 20 }}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </CustomPopover>
  );

  return (
    <>
      <Button
        disableRipple
        color="primary"
        variant="contained"
        onClick={menuActions.onOpen}
        endIcon={
          <Iconify
            icon={menuActions.open ? 'eva:arrow-ios-upward-fill' : 'eva:arrow-ios-downward-fill'}
          />
        }
        sx={{ py: 1, px: 2 }}
      >
        Sıralama
      </Button>

      <Button
        color="secondary"
        variant="contained"
        startIcon={<Iconify icon={!showMap ? 'mynaui:map' : 'eva:list-fill'} />}
        sx={{ py: 1, px: 2, backgroundColor: '#3269af', color: 'white' }}
        onClick={() => setShowMap(!showMap)}
      >
        {!showMap ? 'Haritada Göster' : 'Liste Halinde Göster'}
      </Button>

      {renderMenuActions()}
    </>
  );
}
